// removed by extract-text-webpack-plugin
module.exports = {"root":"Section__root___o4yWG","heading":"Section__heading___1atGq","subHeading":"Section__subHeading___31zzR"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/Section.scss
// module id = 764
// module chunks = 0